import { render, staticRenderFns } from "./VisaTippaniDialog.vue?vue&type=template&id=1629c3a4&"
import script from "./VisaTippaniDialog.vue?vue&type=script&lang=js&"
export * from "./VisaTippaniDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports